// extracted by mini-css-extract-plugin
export default {"side-menu":"side-menu--fXt2W","sideMenu":"side-menu--fXt2W","side-menu__from-right":"side-menu__from-right--EV2YC","sideMenuFromRight":"side-menu__from-right--EV2YC"};